import { classnames } from '@aibees/shared/utils';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { ClientsCommentsGrid } from './components/clients-comments-grid';
import { ClientsCommentsTabs } from './components/clients-comments-tabs';
import { TestimonialVideoModal } from './components/testimonial-video-modal';
import { TESTIMONIALS } from './config';
import { useFilteredTestimonials } from './hooks/use-filtered-testimonials';
import * as SX from './sx';
import type {
  ClientsCommentsProps as Props,
  YoutubeTestimonial,
} from './types';

export const ClientsComments = memo(({ className }: Props) => {
  const { filter, setFilter, filtered, counts } =
    useFilteredTestimonials(TESTIMONIALS);
  const [videoTestimonial, setVideoTestimonial] =
    useState<YoutubeTestimonial | null>(null);

  const handleCloseVideo = useCallback(() => setVideoTestimonial(null), []);

  return (
    <Card
      className={classnames('ClientsComments', className)}
      sx={SX.root}
      variant="filled"
      color="default"
    >
      <CardContent padding="extra">
        <Stack sx={SX.header}>
          <Typography variant="h5" fontWeight={700} color="grey.700" mb={1.5}>
            What Our Clients Say
          </Typography>
          <Typography variant="body4" color="grey.500" mb={3}>
            Real posts from leaders, LinkedIn and YouTube
          </Typography>
        </Stack>
        <ClientsCommentsTabs
          value={filter}
          onChange={setFilter}
          counts={counts}
        />
        <ClientsCommentsGrid
          key={filter}
          testimonials={filtered}
          onSelectVideo={setVideoTestimonial}
        />
        <TestimonialVideoModal
          testimonial={videoTestimonial}
          onClose={handleCloseVideo}
        />
      </CardContent>
    </Card>
  );
});

ClientsComments.displayName = 'ClientsComments';
